import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./styles/DropdownMenu.css";

const DropdownMenu = ({ title, items, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);

  const isGrouped =
    items && !Array.isArray(items) && typeof items === "object";

  const groups = isGrouped
    ? [
        { heading: "Managed Services", list: items.managedServices || [] },
        { heading: "Infrastructure Services", list: items.infrastructureServices || [] },
      ]
    : [{ heading: null, list: items || [] }];

  return (
    <div
      className="dropdown"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button className={`dropdown__trigger ${className}`} type="button">
  <span>{title}</span>
  <svg
    className={`dropdown__arrow ${isOpen ? "dropdown__arrow--open" : ""}`}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
</button>


      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="dropdown__menu"
            initial={{ opacity: 0, y: 16, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.98 }}
            transition={{ duration: 0.22, ease: "easeOut" }}
          >
            {groups.map((group, gi) => (
              <div className="dropdown__group" key={group.heading || gi}>
                {group.heading && (
                  <div className="dropdown__title">{group.heading}</div>
                )}

                <div className="dropdown__group-items">
                  {group.list.map((item, index) => (
                    <Link
                      key={`${item.href}-${index}`}
                      to={item.href}
                      className="dropdown__item"
                    >
                      <span className="dropdown__item-label">{item.label}</span>
                    </Link>
                  ))}
                </div>

                {gi !== groups.length - 1 && <div className="dropdown__divider" />}
              </div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DropdownMenu;
